import { PropsWithChildren } from "react";
import _ from "lodash";
import { SpotifyEnrichmentPreview } from "@/pages/artists/components/spotify-enrichment-preview";
import { Button } from "@/components/ui/button";
import { useArtistCreateForm } from "@/pages/artists/create/hooks/use-artist-create-form";
import {
  ArtistBasicType,
  ArtistSpotifyEnrichmentType,
} from "@/pages/artists/schemas/artist.create.form";

interface SpotifyEnrichmentStepProps {}

const SpotifyEnrichmentStep = ({
  children,
}: PropsWithChildren<SpotifyEnrichmentStepProps>) => {
  const { onSpotifyEnrichmentSubmit, spotifyEnrichmentStep, basicInfoStep } =
    useArtistCreateForm();
  return (
    <div className="flex flex-col gap-4">
      <SpotifyEnrichmentPreview
        info={basicInfoStep as ArtistBasicType}
        spotifyEnrichment={spotifyEnrichmentStep as ArtistSpotifyEnrichmentType}
      />
      <div className="flex justify-center">
        <Button
          onClick={() => {
            onSpotifyEnrichmentSubmit();
          }}
          size="lg"
        >
          Next
        </Button>
      </div>
    </div>
  );
};

export default SpotifyEnrichmentStep;
